module.exports = __webpack_public_path__ + "16874fd7c267ec776e8ab7185835b8e8.png";